import script from "./PwaWageProcessStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaWageProcessStatus.vue?vue&type=script&setup=true&lang=ts"

import "./PwaWageProcessStatus.vue?vue&type=style&index=0&id=2e52f93b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e52f93b"]])

export default __exports__